import isVolumeCompatible from './supportsVolumeCompatibilityApi';
async function setVolumesForViewports(renderingEngine, volumeInputs, viewportIds, immediateRender = false, suppressEvents = false) {
    const compatibleViewports = viewportIds.map((viewportId) => {
        const viewport = renderingEngine.getViewport(viewportId);
        if (!viewport) {
            throw new Error(`Viewport with Id ${viewportId} does not exist`);
        }
        if (!isVolumeCompatible(viewport)) {
            throw new Error('setVolumesForViewports only supports viewports that implement setVolumes');
        }
        return viewport;
    });
    await Promise.all(compatibleViewports.map((viewport) => viewport.setVolumes(volumeInputs, immediateRender, suppressEvents)));
    return;
}
export default setVolumesForViewports;
